import { FieldBase } from '@/components/form';
import { InfoPopover } from '@/components/ui/info';
import { useAnlageassistentFormContext } from '@/domain/mitarbeiter/features/anlageassistent/context/AnlageassistentFormContext';
import { useAnlageassistentContext } from '@/domain/mitarbeiter/features/anlageassistent/context/useAnlageassistentContext';
import { Toggle } from '@e2n/ui';
import { faCircleEuro, faClock } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslation } from 'react-i18next';

export function AuszahlungsgrenzeEinheit() {
  const { t } = useTranslation();
  const form = useAnlageassistentFormContext();
  const { ctx } = useAnlageassistentContext();
  return (
    <div className="flex flex-col gap-4">
      <div className="flex gap-1 items-center">
        <span className="text-neutrals-900 text-xl font-bold leading-7">
          {t(
            'domain.mitarbeiter.create.steps.bezahlung.sollstunden.form.auszahlungsgrenzeEinheit.description',
          )}
        </span>
        <InfoPopover
          text={t(
            'domain.mitarbeiter.create.steps.bezahlung.sollstunden.form.auszahlungsgrenzeEinheit.info',
          )}
        />
      </div>
      <form.AppField
        name="bezahlung.arbeitszeitkonto.stundenloehner.auszahlungsgrenzeEinheit"
        listeners={{
          onChange: () => {
            ctx.resetDependentFields(
              'bezahlung.arbeitszeitkonto.stundenloehner.auszahlungsgrenzeEinheit',
            );
          },
        }}>
        {(field) => (
          <FieldBase>
            <div className="col-span-2 grid md:grid-cols-2 items-start gap-4">
              <Toggle
                pressed={field.state.value === 'euro'}
                onPressedChange={() => field.handleChange('euro')}
                variant={'outline'}
                className="flex items-center justify-start gap-2 p-4 h-auto">
                <FontAwesomeIcon icon={faCircleEuro} />
                <span>
                  {t(
                    'domain.mitarbeiter.create.steps.bezahlung.sollstunden.form.auszahlungsgrenzeEinheit.options.euro',
                  )}
                </span>
              </Toggle>
              <Toggle
                pressed={field.state.value === 'stunden'}
                onPressedChange={() => field.handleChange('stunden')}
                variant={'outline'}
                className="flex items-center justify-start gap-2 p-4 h-auto">
                <FontAwesomeIcon icon={faClock} />
                <span>
                  {t(
                    'domain.mitarbeiter.create.steps.bezahlung.sollstunden.form.auszahlungsgrenzeEinheit.options.stunden',
                  )}
                </span>
              </Toggle>
            </div>
          </FieldBase>
        )}
      </form.AppField>
    </div>
  );
}
